module.exports = __webpack_public_path__ + "static/img/gxg_02.1d05b16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gxg_img/gxg_02.png
// module id = BixZ
// module chunks = 46